import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import useAxiosPrivate from './useAxiosPrivate';
import {
  fetchDicomLogs,
  getDicomLogs,
  getDicomLogsError,
  getDicomLogsLoading,
} from '../pages/slices/dicomLog.slice';
import { API_URL } from '../api/constants'

export const useDicomSenderLogs = (mrn) => {
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();
  const [pageNo, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const dicomeSenderLogsData = useSelector(getDicomLogs);
  const error = useSelector(getDicomLogsError);
  const loading = useSelector(getDicomLogsLoading);

  const queryOptions = useMemo(() => ({ pageNo, pageSize }), [pageNo, pageSize]);

  const buildQueryString = useCallback(
    (options) => {
      const queryParams = {
        pageNo,
        pageSize,
        mrn,
        ...(options?.filter && options?.value
          ? { [options.filter]: options.value }
          : {}),
        ...(options?.startDate && options?.endDate
          ? {
              from_date: dayjs(options.startDate).format('YYYY-MM-DD'),
              till_date: dayjs(options.endDate).format('YYYY-MM-DD'),
            }
          : {}),
      };

      return Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');
    },
    [pageNo, pageSize, mrn]
  );

  const fetchDicomLogsData = useCallback(
    (options = {}) => {
      const queryString = buildQueryString(options);
      dispatch(
        fetchDicomLogs({
          axiosInstance: axiosPrivate,
          path: `${API_URL.DICOM_SENDER_LOGS}?${queryString}`,
        })
      );
    },
    [axiosPrivate, buildQueryString, dispatch]
  );

  useEffect(() => {
    fetchDicomLogsData();
  }, [queryOptions, fetchDicomLogsData]);

  return {
    dicomeSenderLogsData,
    error,
    loading,
    pageNo,
    pageSize,
    setPage,
    setPageSize,
  };
};